import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dialog from '@material-ui/core/Dialog'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'
import Select from '@material-ui/core/Select'

import '../styles/cameraSetting.scss'

export default function CameraSetting(props) {
    const {
        isAudio: prevIsAudio,
        videoRatio: prevVideoRatio,
        selectedCamera,
        selectedMicrophone,
    } = props

    const prevSelectedCameraId = selectedCamera && selectedCamera.deviceId
    const prevSelectedMicrophoneId =
        selectedMicrophone && selectedMicrophone.deviceId

    const [isAudio, setIsAudio] = useState(prevIsAudio)
    const [videoRatio, setVideoRatio] = useState(prevVideoRatio)
    const [selectedCameraId, setSelectedCameraId] = useState(
        prevSelectedCameraId
    )
    const [selectedMicrophoneId, setSelectedMicrophoneId] = useState(
        prevSelectedMicrophoneId
    )

    React.useEffect(() => {
        setIsAudio(prevIsAudio)
        setVideoRatio(prevVideoRatio)
        if (prevSelectedCameraId) {
            setSelectedCameraId(prevSelectedCameraId)
        }
        if (prevSelectedMicrophoneId) {
            setSelectedMicrophoneId(prevSelectedMicrophoneId)
        }
    }, [
        props.isAudio,
        props.videoRatio,
        props.selectedCamera,
        props.selectedMicrophone,
        props.isShowSettingDialog,
        prevIsAudio,
        prevVideoRatio,
        prevSelectedCameraId,
        prevSelectedMicrophoneId,
    ])

    const { isShowSettingDialog } = props

    function handleDone() {
        let updateObj = {}

        if (isAudio !== prevIsAudio) {
            updateObj['isAudio'] = isAudio
        }
        if (videoRatio !== prevVideoRatio) {
            updateObj['videoRatio'] = videoRatio
        }
        if (selectedCameraId !== prevSelectedCameraId) {
            updateObj['selectedCameraId'] = selectedCameraId
        }
        if (selectedMicrophoneId !== prevSelectedMicrophoneId) {
            updateObj['selectedMicrophoneId'] = selectedMicrophoneId
        }
        props.updateState(updateObj)

        props.closeSettingDialog()
    }

    function handleCancel() {
        setIsAudio(prevIsAudio)
        setVideoRatio(prevVideoRatio)
        setSelectedCameraId(prevSelectedCameraId)
        setSelectedMicrophoneId(prevSelectedMicrophoneId)
        props.closeSettingDialog()
    }

    let errorHint = null
    function renderMicrophoneSelect() {
        const {
            cameraList,
            microphoneList,
            isGrantedMicrophonePermission,
        } = props

        let errorMessage = null
        if (microphoneList.length === 0) {
            errorMessage = 'NoMicrophoneAccessible'
        }
        if (!isGrantedMicrophonePermission) {
            errorMessage = 'MicrophoneIsBlocked'
            errorHint = (
                <p className="setting-item__hint">
                    <FormattedMessage id="allowMicrophone" />
                    <a
                        href="https://alfredlabs.page.link/permission-camera_preview-webcam"
                        target="__blank"
                    >
                        <FormattedMessage id="knowMore" />
                    </a>
                </p>
            )
        }

        const disabled = errorMessage !== null || cameraList.length === 0

        return (
            <div>
                <ListItem className="setting-item">
                    <InputLabel
                        className={`setting-item__label setting-item__label${
                            disabled ? '_disabled' : ''
                        }`}
                    >
                        {isAudio ? (
                            <FormattedMessage id="On" />
                        ) : (
                            <FormattedMessage id="Off" />
                        )}
                    </InputLabel>
                    <ListItemSecondaryAction style={{ right: -10 }}>
                        <Switch
                            disabled={disabled}
                            onChange={(event) =>
                                setIsAudio(event.target.checked) &&
                                event.stopPropagation()
                            }
                            checked={isAudio}
                        />
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem className="setting-item">
                    <InputLabel
                        htmlFor="micrphone-selector"
                        className={`setting-item__label setting-item__label${
                            disabled ? '_disabled' : ''
                        }`}
                    >
                        <FormattedMessage id="microphone" />
                    </InputLabel>
                    <FormControl
                        className="setting-item__switch"
                        disabled={disabled}
                    >
                        {errorMessage !== null ? (
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={errorMessage}
                                onChange={(event) =>
                                    setSelectedMicrophoneId(
                                        event.target.value
                                    ) && event.stopPropagation()
                                }
                                label="Microphone"
                            >
                                <MenuItem value={errorMessage}>
                                    <FormattedMessage id={errorMessage} />
                                </MenuItem>
                            </Select>
                        ) : (
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={selectedMicrophoneId}
                                onChange={(event) =>
                                    setSelectedMicrophoneId(
                                        event.target.value
                                    ) && event.stopPropagation()
                                }
                                label="Microphone"
                                renderValue={(microphoneId) => {
                                    const microphone = microphoneList.find(
                                        (mic) => mic.deviceId === microphoneId
                                    )

                                    if (!microphone) {
                                        return (
                                            selectedMicrophone &&
                                            selectedMicrophone.label
                                                .replace(
                                                    /\([0-f]+:[0-f]+\)/,
                                                    ''
                                                )
                                                .trim()
                                        )
                                    }

                                    return microphone.label
                                        .replace(/\([0-f]+:[0-f]+\)/, '')
                                        .trim()
                                }}
                            >
                                {microphoneList.map((microphone) => (
                                    <MenuItem
                                        value={microphone.deviceId}
                                        key={microphone.deviceId}
                                    >
                                        {microphone.label
                                            .replace(/\([0-f]+:[0-f]+\)/, '')
                                            .trim()}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    </FormControl>
                </ListItem>
            </div>
        )
    }

    function renderCameraSelect() {
        const { cameraList, isFree } = props

        const disabled = cameraList.length === 0
        if (disabled) {
            errorHint = (
                <p className="setting-item__hint">
                    <FormattedMessage id="setUpCameraFirst" />
                </p>
            )
        }
        return (
            <div>
                {isFree ? (
                    ''
                ) : (
                    <ListItem className="setting-item">
                        <InputLabel
                            className={`setting-item__label setting-item__label${
                                disabled ? '_disabled' : ''
                            }`}
                        >
                            <FormattedMessage id="aspectRatio" />
                        </InputLabel>
                        <FormControl
                            className="setting-item__switch"
                            disabled={disabled}
                        >
                            <Select
                                labelId="aspect-ratio-selector"
                                value={videoRatio}
                                onChange={(event) =>
                                    setVideoRatio(event.target.value) &&
                                    event.stopPropagation()
                                }
                                label="videoRatio"
                            >
                                <MenuItem value={false}> 4:3 </MenuItem>
                                <MenuItem value={true}> 16:9 </MenuItem>
                            </Select>
                        </FormControl>
                    </ListItem>
                )}
                <ListItem className="setting-item">
                    <InputLabel
                        htmlFor="camera-selector"
                        className={`setting-item__label setting-item__label${
                            disabled ? '_disabled' : ''
                        }`}
                    >
                        <FormattedMessage id="camera" />
                    </InputLabel>
                    <FormControl
                        className="setting-item__switch"
                        disabled={disabled}
                    >
                        {disabled ? (
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value="No camera accessible"
                                label="Camera"
                            >
                                <MenuItem value="No camera accessible">
                                    <FormattedMessage id="CameraInaccessible" />
                                </MenuItem>
                            </Select>
                        ) : (
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={selectedCameraId}
                                onChange={(event) =>
                                    setSelectedCameraId(event.target.value) &&
                                    event.stopPropagation()
                                }
                                label="Camera"
                                renderValue={(cameraId) => {
                                    const camera = cameraList.find(
                                        (cam) => cam.deviceId === cameraId
                                    )

                                    if (!camera) {
                                        return (
                                            selectedCamera &&
                                            selectedCamera.label
                                                .replace(
                                                    /\([0-f]+:[0-f]+\)/,
                                                    ''
                                                )
                                                .trim()
                                        )
                                    }

                                    return camera.label
                                        .replace(/\([0-f]+:[0-f]+\)/, '')
                                        .trim()
                                }}
                            >
                                {cameraList.map((camera) => (
                                    <MenuItem
                                        value={camera.deviceId}
                                        key={camera.deviceId}
                                    >
                                        {camera.label
                                            .replace(/\([0-f]+:[0-f]+\)/, '')
                                            .trim()}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    </FormControl>
                </ListItem>
            </div>
        )
    }

    function renderItems() {
        return (
            <div>
                <div className="setting-dialog__column">
                    <p className="setting-dialog__column-title">
                        <FormattedMessage id="audio" />
                    </p>
                    {renderMicrophoneSelect()}
                </div>

                <div className="setting-dialog__column">
                    <p className="setting-dialog__column-title">
                        <FormattedMessage id="video" />
                    </p>
                    {renderCameraSelect()}
                </div>
                {errorHint !== null ? errorHint : ''}
            </div>
        )
    }

    return (
        <Dialog
            className="camera-setting-modal"
            onClose={handleCancel}
            aria-labelledby="simple-dialog-title"
            open={isShowSettingDialog}
        >
            <div className="camera-setting-modal-container">
                <List className="setting-dialog">{renderItems()}</List>
                <DialogActions>
                    <Button onClick={() => handleCancel()} color="secondary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={() => handleDone()} color="secondary">
                        <FormattedMessage id="done" />
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    )
}
